import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { FI_MARKETPLACE_OFFERS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useFiMarketplaceOffers({
  shouldNotifyOnChange = true
}: { shouldNotifyOnChange?: boolean } = {}) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const { data: fiMarketplaceOffersData, isLoading: isLoadingFiMarketplaceOffers } = useQuery({
    enabled: !!userBankId,
    queryKey: [FI_MARKETPLACE_OFFERS_KEY, userBankId],
    queryFn: () => banksApi.getFiMarketplaceOffers(userBankId, true),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  return { fiMarketplaceOffersData, isLoadingFiMarketplaceOffers };
}
